const platform = () => {
  return /iPhone|iPod|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
}

export default platform()
